import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as PageContext } from '../../contexts/PageContext';
import PAGE_COMPONENT from './PrivacyPolicy';

// eslint-disable-next-line no-undef
const props = globalPageProps || {};

ReactDOM.hydrateRoot(
    document.getElementById('root'),
    <PageContext PAGE_PROPS={props.PAGE_PROPS}>
        <PAGE_COMPONENT {...props} />
    </PageContext>
);

/**
 *  To render the component:
 *
 *  req.reactRender = {
 *      componentPath: 'PrivacyPolicy/PrivacyPolicy,
 *      props: {},
 *      metaTagData:{}
 *  }
 *
 *  next();
 *  return;
 *
 */
